"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TWITCH_MAX_MESSAGE_LENGTH = void 0;
// Twitch enforces a maximum of 500 characters per chat message
exports.TWITCH_MAX_MESSAGE_LENGTH = 500;
//# sourceMappingURL=constants.js.map